module.exports = __webpack_public_path__ + "images/zorgzaam3c00071b5178499ec7c9adada90bdf75.png";